import { User } from 'projects/core/src/lib/login/data/user';
import { DateConverter, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ClientNotification } from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs';

@JsonObject('model.INSTALLATION_QUOTE_CLIENT_NOTIFICATION')
export class ActivityQuote extends ClientNotification {
    @JsonProperty(User, 'addressee')
    addressee?: User;

    @JsonProperty(String, 'awardMsg')
    awardMsg?: string;

    @JsonProperty(DateConverter, 'awardSent')
    awardSent?: Date;

    @JsonProperty(String, 'awardSentTo')
    awardSentTo?: string;

    @JsonProperty(User, 'awardSentBy')
    awardSentBy?: User;

    @JsonProperty(Number, 'price')
    price?: number;
}